<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="6" style="text-align: center"></b-th>
          <b-th colspan="2" style="text-align: center">出勤情况</b-th>
          <b-th colspan="3" style="text-align: center">发放基数</b-th>
          <b-th colspan="2" style="text-align: center">出勤</b-th>
          <b-th colspan="3" style="text-align: center">目标责任状</b-th>
          <b-th colspan="2" style="text-align: center">缺勤扣款情况</b-th>
          <b-th colspan="2" style="text-align: center">日常考核扣款情况</b-th>
          <b-th colspan="2" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}"></div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(absenceFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'absenceFee') }}</div>
      </template>
      <template v-slot:foot(perfdailyFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'perfdailyFee') }}</div>
      </template>
      <template v-slot:foot(cutFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'cutFee') }}</div>
      </template>
      <template v-slot:foot(theoryFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'theoryFee') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "HrPerfPromiseScoreDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'corpName', label: '公司名称', width: '140px'},
        {key: 'orgName', label: '部门名称', width: '120px'},
        {key: 'stationName', label: '岗位名称', width: '120px'},
        {key: 'employeeName', label: '员工姓名', width: '120px'},
        {key: 'bonusCorpName', label: '发放公司', width: '130px'},
        {key: 'attnMonths', label: '出勤月数', width: '120px'},
        {key: 'attnDays', label: '应出勤天数', width: '130px'},
        {key: 'monthSalary', label: '月薪酬标准', width: '130px'},
        {key: 'bonusBase', label: '年终奖金月基数', width: '130px'},
        {key: 'bonusTheoryFee', label: '按月数应发年终奖金', width: '140px'},
        {key: 'attnPercent', label: '占比', width: '100px'},
        {key: 'attnFee', label: '红包金额', width: '130px'},
        {key: 'promisePercent', label: '占比', width: '100px'},
        {key: 'promiseScore', label: '得分', width: '100px'},
        {key: 'promiseFee', label: '红包金额', width: '130px'},
        {key: 'absenceDays', label: '缺勤扣款天数', width: '130px'},
        {key: 'absenceFee', label: '缺勤扣款金额', width: '130px'},
        {key: 'perfdailyFee', label: '全年考核金额', width: '130px'},
        {key: 'cutFee', label: '考核扣款金额', width: '130px'},
        {key: 'theoryFee', label: '应发金额小计', width: '130px'},
        {key: 'remark', label: '备注', width: '130px'},
      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total;
      }, 0).toFixed(2, Decimal.ROUND_HALF_UP);
    }
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
